/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSelectItemCatalogueButtonStyles = makeStyles(theme => ({
  iconCheck: {
    opacity: 0,
  },
  iconArrow: {
    transform: 'rotate(-90deg)',
    opacity: 0,
  },
  item: {
    textTransform: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px 6px 8px 14px',
    color: theme.palette.text.primary,
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'left',
    borderRadius: '6px',
    transition: 'all .2s linear',
    fontWeight: 500,
    letterSpacing: '-0.52px',
    '&.Mui-disabled': {
      opacity: '0.7',
      pointerEvents: 'auto',
    },
    '&:hover:not($itemActive):not(&.Mui-disabled)': {
      backgroundColor: `${theme.palette.tertiary.main}20`,
      color: theme.palette.text.primary,
    },
    '&$itemActive': {
      color: theme.palette.text.primary,
      backgroundColor: `${theme.palette.tertiary.main}20`,
      '& $iconCheck, & $iconArrow, & .iconCheck, & .iconArrow': {
        opacity: 1,
      },
    },
  },
  itemActive: {},
}));
